import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6b5c52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-list" }
const _hoisted_2 = { class: "mb-4 mb-lg-5 d-flex flex-column flex-lg-row justify-content-center align-items-center position-relative" }
const _hoisted_3 = { class: "text-center d-inline-block mx-auto fw-bold mb-0 fs-5 pb-2 text-center mb-4 mb-lg-0" }
const _hoisted_4 = {
  key: 0,
  class: "link-direct"
}
const _hoisted_5 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-message" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "text-center fw-bold fs-4 my-5"
}

import { computed, onMounted, ref, watch, onUnmounted, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import ChartCard from '../components/ChartCard.vue'
import Link from '@/components/link/index.vue'
import { translate } from '@/languages/i18n'
import { COMMUNITY_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import PostSkeleton from '@/components/skeletons/PostSkeleton.vue'
import Tabs from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import { CommunityStateTypes } from '@/store/modules/community'
import { omit } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const dataChatrooms = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.CHATROOMS])
const profileCommunity = computed<CommunityStateTypes>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])

const page = ref<number>(1)

const observer = ref()

const lastPost = ref<HTMLElement>()

const tabs = computed(() => {
  const t = [
    {
      title: translate('all'),
      alias: 'all',
    },
    {
      title: translate('interest'),
      alias: 'interested',
    },
  ]
  if (profileCommunity.value.post_recruitment_permission) {
    t.push({
      title: translate('SM10myPost'),
      alias: 'my_posts',
    })
  }
  return t
})
const getChatrooms = (page: number, change) => {
  if (!route?.params?.id) return
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_CHATROOMS, { change, id: route?.params?.id, params: { tab: tabs.value[0].alias, ...route?.query, ...(page && { page }) } })
}

onMounted(() => {
  getChatrooms(page.value, true)
})

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (dataChatrooms.value.total_records < 20) {
        return
      } else {
        page.value++
        getChatrooms(page.value)
      }
    }
  })
  if (lastPost.value) {
    observer?.value?.observe(lastPost.value)
  }
})
// 2022/10/11 NamPH7425 SM10 (Ph2-R202201021)

watch(
  () => lastPost.value,
  () => {
    if (lastPost.value) {
      observer?.value?.observe(lastPost.value)
    }
  }
)

watch(
  () => route.query,
  (newVal, oldVal) => {
    const { tab: newTab } = newVal
    const { tab: oldTab } = oldVal

    if (!oldTab || newTab !== oldTab) {
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_CHATROOMS, {
        reset: true,
        change: true,
        id: route?.params?.id,
        params: {
          ...route?.query,
          page: 1,
        },
      })
    }
  }
)

watchEffect(() => {
  if (profileCommunity.value.id) {
    // Select すべて tab in cased of community doesn't have post recruitment permission
    // and user are trying to enter 自分の投稿 by url
    if (!profileCommunity.value.post_recruitment_permission && route.query.tab && route.query.tab.toString() === 'my_posts') {
      router.replace({ path: route.path, query: omit(route.query, 'tab') })
      return
    }

    // Select すべて by default when tab parameter in url not correct
    if (!['all', 'interested', 'my_posts'].includes(route.query.tab?.toString() ?? '')) {
      router.replace({ path: route.path, query: omit(route.query, 'tab') })
    }
  }
})

onUnmounted(() => {
  observer.value?.disconnect()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translate)('chatList')), 1),
      (_unref(dataChatrooms)?.direct_chatroom_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(dataChatrooms)?.unread_count)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            _createVNode(Link, {
              path: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).path?.split('/')[3]}/direct_chat/${_unref(dataChatrooms)?.direct_chatroom_id}`,
              title: _unref(translate)('SM10directManager')
            }, null, 8, ["path", "title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Tabs, {
      tabs: _unref(tabs),
      "default-alias": _unref(tabs)[0].alias,
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
          return (_openBlock(), _createBlock(TabPanel, {
            alias: tab.alias,
            keyName: index + 1,
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataChatrooms).chatrooms, (room, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(ChartCard, {
                      data: room,
                      isAdmin: false
                    }, null, 8, ["data"])
                  ]))
                }), 128))
              ]),
              (_unref(dataChatrooms).chatrooms.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['lastPost'] = _value
                      lastPost.value = _value
                    }
                  }, null, 512))
                : _createCommentVNode("", true),
              (_unref(dataChatrooms)?.loadingData)
                ? (_openBlock(), _createBlock(PostSkeleton, { key: 1 }))
                : _createCommentVNode("", true),
              (!_unref(dataChatrooms)?.loadingData && !_unref(dataChatrooms).chatrooms?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('SM10nochat')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["alias", "keyName"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["tabs", "default-alias"])
  ]))
}
}

})